export default "__VITE_ASSET__f47e3958__"